import React, { useEffect, useRef, useState } from 'react';
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { useHeaderContext } from './HeaderContext';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { setTime } from 'react-datepicker/dist/date_utils';
interface TourProps {
  setTourCount: (count: number) => void;
  userData:any;
}

const Tour: React.FC<TourProps> = ({ setTourCount,userData}) => {
  const { setIsValyria } = useHeaderContext();
  const driverRef = useRef<ReturnType<typeof driver> | null>(null);
  let navigate = useNavigate()
  const location = useLocation();
  const [showTourButton, setShowTourButton] = useState(location.pathname === '/chat'); // Initialize based on initial location

  useEffect(() => {
    setShowTourButton(location.pathname === '/chat');
  }, [location]);
  useEffect(()=>{
  sessionStorage.setItem("UserRole",userData?.role)
  },[userData?.role])

  useEffect(() => { 
    const driverObj = driver({
      onDestroyStarted:()=>{
        driverObj.destroy()
        sessionStorage.removeItem("UserRole")
        window.location.href = '/chat';
      },
    
      steps: [
        {
          element: '.asami-logo',
          popover: {
            title: 'Asami 4.0',
            showButtons: ['next'],
            description: 'Introducing Asami 4.0! Click next to explore our latest features.',
          },

        },
        {
          element: '.file-tour',
          popover: {
            title: 'Enhanced File Upload',
            description: 'The file upload section now includes new features for a faster, more efficient experience',
            popoverClass: 'custom-popover-class',
            showButtons: ['next'],
            onNextClick: () => {
              const button = document.querySelector('.file-tour') as HTMLTextAreaElement;
              button.click()
              setTimeout(()=>{
                driverObj.moveNext()
              },200)
            },
          },
        },
        {
          element: '.files-tour',
          popover: {
            title: 'Multiple File Uploads',
            description: 'Asami now supports uploading multiple files at once to streamline your workflow.',
            popoverClass: 'custom-popover-class',
            showButtons: ['next'],
          },
        },
        {
          element: '.folder-tour',
          popover: {
            title: 'Folder Upload Support',
            description: 'You can upload entire folder, including all contents and nested subfolders, in one step.',
            popoverClass: 'custom-popover-class',
            showButtons: ['next'],
          },
        },
        {
          element: '.knowledgebase-tour',
          popover: {
            title: 'Custom Knowledge Base',
            description: 'You can now upload your own chats to Asami\'s custom knowledge base. By leveraging the context from previous conversations, Asami will deliver more precise and relevant answers to your current queries',
            popoverClass: 'custom-popover-class',
            showButtons: ['next'],
            onNextClick: () => {
              const button = document.querySelector('.file-tour') as HTMLTextAreaElement;
              button.click()
              driverObj.moveNext()
            },
          },
        },
        {
          element: '.sendMessage',
          popover: {
            title: 'New Chat Features',
            description: 'Try "/" to see what’s new.',
            popoverClass: 'custom-popover-class',
            showButtons: ['next'],
            onPopoverRender:(popover,{driver})=>{
              const textarea = document.querySelector('#asamiTextArea') as HTMLTextAreaElement;
              const nextBtn = popover.nextButton;

              nextBtn.hidden = true

              const checkInput = () => {
                if (textarea.value.includes('/')) {
                  nextBtn.hidden = false;
                } else {
                  nextBtn.hidden = true;

                }
              };
              textarea.addEventListener('input', checkInput);
           
            }
          },

        },
        
        
   
        {
          element: '.prompt-tour',
          popover: {
            title: '/Prompt',
            showButtons: ['next'],
            description: 'Select or type "/Prompt" and describe your requirements. Asami will select the optimal prompt for your needs to deliver the best results. If additional information is needed, a pop-up will appear to collect necessary details.',
            onPrevClick: () => {
              driverObj.moveTo(1);
            },
          },
         
        },
        {
          element: '.codegen-tour',
          popover: {
            title: '/CodeGen',
            description: 'Need to generate code from designs? Upload your designs and type "/CodeGen" - Asami will create the code for you.',
            showButtons: ['next'],
            onNextClick: () => {
               driverObj.moveNext() 
            },
            
          
          },
        },
        {
          element: '.codegen-tour',
          popover: {
            title: '/CodeGen',
            description: 'When uploading your sequence diagram, please ensure that the file name includes the word "sequence" or "seq" for easy identification.',
            showButtons: ['next'],
            onNextClick: () => {
              setTourCount(2)
               driverObj.moveNext() 
            },
            
          
          },
        },
        {
          element: '.chatpage',
          popover: {
            title: 'CodeGen Space',
            description: 'Welcome to the CodeGen space',
            showButtons: ['next'],
            onPrevClick:()=>{ 
              const textarea = document.querySelector('#asamiTextArea') as HTMLTextAreaElement;
                textarea.value = "";
                setTourCount(-2)
                driverObj.moveTo(1) 
                   }
    
              },
        },
        // {
        //   element: '.none',
        //   popover: {
        //     title: 'Chat',
        //     description: 'For simple use cases, Asami generates code and provides responses directly in the chat.',
        //     showButtons: ['next'],
        //     onPrevClick:()=>{
        //       driverObj.movePrevious()
        //     }
        //   },
        // },
        {
          element: '.right-nav-container',
          popover: {
            title: 'Chat',
            description: 'Asami utilizes its built-in terminal, browser, and debugger to develop your code. Simply upload your designs and download the completed code as a zip file.',
            showButtons: ['next'],
            onPrevClick:()=>{
              driverObj.movePrevious()
            }
          },
        },
        {
          element: '.planner',
          popover: {
            title: 'Planner',
            description: 'Asami will analyze your designs and provide you with core logics for your codebase. You can view and edit the planner to modify your code base according to your preference',
            showButtons: ['next'],
            onPrevClick:()=>{
              driverObj.movePrevious()
            }
          },
        },
        {
          element: '.codespace',
          popover: {
            title: 'CodeSpace',
            description: 'You can view the code generated by Asami after the CodeGen process gets completed here. You can also download the code as a zip file .',
            showButtons: ['next'],
            onPrevClick:()=>{
              driverObj.movePrevious()
            }
          },
        },
        {
          element: '.terminal',
          popover: {
            title: 'Terminal',
            description: 'You can view all the background process that takes place in the inbuilt terminal over here.',
            showButtons: ['next'],
            onPrevClick:()=>{
              driverObj.movePrevious()
            }
          
          },
        },
        {
          element: '.debugger',
          popover: {
            title: 'Browser',
            description: 'Asami will automatically scrape data and generate or fix code based on it. You can also view the websites that were used as sources for the content right here.',
            showButtons: ['next'],
            onPrevClick:()=>{
              driverObj.movePrevious()
            },
            onNextClick: () => {
              setTourCount(-2)
              if(sessionStorage.getItem("UserRole")=="Leadership"){
              navigate('/asami-manage-execution');
              driverRef.current?.moveNext();
              }
              else{
                driverObj.moveTo(24)
              }

            },
          },
        },
        {
          element: '.manage-prompt',
          popover: {
            title: 'Manage Execution',
            description: 'Welcome to Manage Execution',
            popoverClass:"manage-execution",
            showButtons: ['next'],
            onPrevClick:()=>{
              driverObj.movePrevious()
            },
            onNextClick: () => {
              setTourCount(-2)
              driverRef.current?.moveNext();
              
            },
          },
        },
        {
          element: '.practice-highlight',
          popover: {
            title: 'Manage Execution',
            description: 'You can select your practice from this grid',
            showButtons: ['next'],
            onNextClick: () => {
              const button = document.querySelector('.practice-highlight') as HTMLTextAreaElement;
              button.click()
              driverObj.moveNext()
            }
            
          },

        },
        {
          element: '.durrr',
          popover: {
            title: 'Please Wait',
            description: 'Just a second...',
            showButtons: [],
            
          },
          onHighlighted:()=>{
              setTimeout(()=>{
                driverObj.moveNext()
              },5000)
           
          }
        },
        // {
        //   element: '.burrr',
        //   popover: {
        //     title: 'Success',
        //     description: 'This is the page header where you can find the main title and navigation.',
        //     showButtons: ['next'],
        //   },
        // },
        {
          element: '.prompt-tour',
          popover: {
            title: 'Add Prompt',
            description: 'Create new prompt from the prompt creation section.',
            showButtons: ['next'],
          },
        },
        {
          element: '.edit-click',
          popover: {
            title: 'Edit Prompt',
            description: 'You can edit your prompts here as usual.',
            showButtons: ['next'],
          },
        },
        {
          element: '.Rule',
          popover: {
            title: 'Welcome to Rules tab',
            description: 'Optimize your workflow by deciding when to engage Asami\'s powerful processing capabilities.',
            showButtons: ['next'],
            onNextClick: () => {
              const button = document.querySelector('.Rule') as HTMLTextAreaElement;
              button.click()
              driverObj.moveNext()
            }
          },
        },
        {
          element: '.durrr',
          popover: {
            title: 'Please Wait',
            description: 'Just a second...',
            showButtons: [],
          },
          onHighlighted:()=>{
              setTimeout(()=>{
                driverObj.moveNext()
              },5000)
           
          }
        },
        {
          element: '.none',
          popover: {
            title: 'Rules Tab',
            description: 'Asami can dedicate additional computational resources to deliver comprehensive solutions.',
            showButtons: ['next'],
            
          },
        },
        {
          element: '.rules-grid-requirement',
          popover: {
            title: 'Requirement',
            description: 'Set up your rules here to direct your use case to Valyria for advanced execution. \n Example : A login page using Microsoft AD login',
            showButtons: ['next'],
            
          },
        },
        {
          element: '.dropdown-rule',
          popover: {
            title: 'Rules Drop Down',
            description: 'Select your preferred option from the dropdown. Choose Valyria for maximum processing capability, or Asami for standard execution.',
            showButtons: ['next'],
            
          },
          onHighlighted:()=>{
            let dropDown = document.querySelector('select__control') as HTMLButtonElement
            dropDown?.click()


          }
        },

        {
          element: '.burrrr',
          popover: {
            title: 'Thank You',
            description: 'For any additional queries, reach out to Asami Support.',
            showButtons: ['next'],
            
          },
          onHighlighted:()=>{
            let dropDown = document.querySelector('select__control') as HTMLButtonElement
            dropDown?.click()


          }
        },
      ],
    });

    driverRef.current = driverObj;
  }, [setIsValyria, setTourCount]);

  const startTour = () => {
    driverRef.current?.drive();
  };

  return (
    <div>
      {
      showTourButton && 
      <button onClick={startTour} className='top-bar-button text-color-9 font-14'>
        Start Tour
      </button>
      }
    </div>
  );
};

export default Tour;
